"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignRequest = void 0;
var SignRequest = /** @class */ (function () {
    function SignRequest() {
    }
    return SignRequest;
}());
exports.SignRequest = SignRequest;
;
//# sourceMappingURL=sign.request.js.map